import { SearchIcon, XIcon } from "lucide-react";
import { useRef } from "react";

import { cn } from "@/lib/utils";

type SearchBarProps = {
  query: string;
  onQueryChange: (query: string) => void;
};

export function SearchBar({ query, onQueryChange }: SearchBarProps) {
  const inputRef = useRef<HTMLInputElement>(null);

  return (
    <div className="relative">
      <SearchIcon className="absolute left-3.5 top-1/2 -translate-y-1/2 size-4 text-white/40 pointer-events-none" />

      <input
        ref={inputRef}
        type="text"
        value={query}
        onChange={e => onQueryChange(e.target.value)}
        placeholder="단어 또는 뜻으로 검색"
        className={cn(
          "w-full h-10 pl-9.5 pr-9.5 bg-white/12 rounded-xl text-sm text-white placeholder:text-white/40",
          "outline-none border border-transparent transition-all",
          "focus:border-white/25",
        )}
      />

      {query && (
        <button
          type="button"
          onClick={() => {
            onQueryChange("");
            inputRef.current?.focus();
          }}
          className="absolute right-2.5 top-1/2 -translate-y-1/2 size-5 flex items-center justify-center rounded-full bg-white/15 text-white/60 hover:text-white/80 transition-colors"
        >
          <XIcon className="size-3" />
        </button>
      )}
    </div>
  );
}
